(function () {
  var scrollDepth;

  init();

  function init() {
    scrollDepth = {
      load: false,
      breakpoint : {
        10: {
          load: false,
          fire: false,
          name: "scroll_10_poc"
        } ,
        25: {
          load: false,
          fire: false,
          name: "scroll_25_poc"
        },
        50: {
          load: false,
          fire: false,
          name: "scroll_50_poc"
        },
        75: {
          load: false,
          fire: false,
          name: "scroll_75_poc"
        },
        100: {
          load: false,
          fire: false,
          name: "scroll_100_poc"
        }
      }
    }

    window.addEventListener('scroll', trackScrollDepth);
    window.addEventListener('load', trackLoadDepth);
  }

  // Function to calculate and track scroll depth
  function trackScrollDepth() {
    var scrollHeight = document.documentElement.scrollHeight,
    windowHeight = window.innerHeight,
    scrollTop = window.scrollY,
    scrollPercent = (scrollTop / (scrollHeight - windowHeight)) * 100,
    currPercent = Math.round(scrollPercent);

    //load
    Object.keys(scrollDepth.breakpoint).forEach(function (key) {
      if (currPercent >= key && !scrollDepth.breakpoint[key].load) {
        scrollDepth.breakpoint[key].load = true;
      }
    });

    //when load event fire
    if (scrollDepth.load) {
      scrollEventFire();
    }
  }

  function trackLoadDepth() {
    scrollDepth.load = true;

    gtag('js', new Date());
    gtag('config', 'G-BBS5LEDVRG');

    scrollEventFire();
  }

  function gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments); 
  }
  
  function scrollEventFire() {
    Object.keys(scrollDepth.breakpoint).forEach(function (key) {
      if (scrollDepth.breakpoint[key].load && !scrollDepth.breakpoint[key].fire) {
        scrollDepth.breakpoint[key].fire = true;
        gtag('event', scrollDepth.breakpoint[key].name);
      }
    });
  }
})();